import { z } from 'zod';
import { Gwei } from '../lib/gwei';

export const OrderFillsSchema = z.object({
  data: z.array(
    z.object({
      orderId: z.string().uuid(),
      price: z.string().transform(Gwei.toGwei),
      filled: z.string().transform(Gwei.toGwei),
      side: z.union([z.literal(0), z.literal(1)]),
      feeUsd: z.string().transform(Gwei.toGwei),
      isMaker: z.boolean(),
      productId: z.string().uuid(),
      createdAt: z.number().int().positive(),
    })
  ),
});

export type OrderFills = z.infer<typeof OrderFillsSchema>;
